"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_POLLING_INTERVAL = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isNull = _interopRequireDefault(require("lodash/isNull"));
var _qs = _interopRequireDefault(require("qs"));
var componentEvents = _interopRequireWildcard(require("./constants"));
var _DebugManager = _interopRequireDefault(require("../utils/DebugManager"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dmInstance = _DebugManager["default"].dmInstance;
var UNAUTHENTICATED = 'UNAUTHENTICATED';
var EventStatusEnum = componentEvents.EventStatusEnum,
  DestinationTypeEnum = componentEvents.DestinationTypeEnum;
var ARCHIVED = EventStatusEnum.ARCHIVED,
  STAGED = EventStatusEnum.STAGED,
  COMPLETED = EventStatusEnum.COMPLETED;
var DEFAULT_POLLING_INTERVAL = exports.DEFAULT_POLLING_INTERVAL = 5000;
var HTTPEvent = exports["default"] = /*#__PURE__*/function () {
  function HTTPEvent(dataHandler, errorHandler, config) {
    var _this = this;
    _classCallCheck(this, HTTPEvent);
    _defineProperty(this, "close", function () {
      clearInterval(_this.pollIntervalReference);
      _this.pollIntervalReference = 0;
      _this.nextIds = {
        viewer: null,
        producer: null
      };
      _this.reset();
    });
    _defineProperty(this, "reset", function () {
      _this.eventList = [];
    });
    _defineProperty(this, "pollHandler", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(eventId, accountId, componentEventHost) {
        var previewToken,
          producerEvents,
          viewerEvents,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              previewToken = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
              producerEvents = [];
              viewerEvents = [];
              _context.prev = 3;
              if (!_this.config.isProducer) {
                _context.next = 11;
                break;
              }
              _context.next = 7;
              return _this.getComponentEvents(DestinationTypeEnum.PRODUCER, eventId, accountId, componentEventHost);
            case 7:
              producerEvents = _context.sent;
              _this.dataHandler(producerEvents);
              _context.next = 15;
              break;
            case 11:
              _context.next = 13;
              return _this.getComponentEvents(DestinationTypeEnum.VIEWER, eventId, accountId, componentEventHost, previewToken);
            case 13:
              viewerEvents = _context.sent;
              _this.dataHandler(viewerEvents, true);
            case 15:
              _this.retryCounter = 0;
              _context.next = 22;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](3);
              console.error('[HTTPEvent] Problem getting component events while polling', _context.t0);

              //Need to force re-authentication when receiving a 401
              if (_context.t0.response && _context.t0.response.status == 401) {
                _this.close();
                _this.store.dispatch({
                  type: UNAUTHENTICATED
                });
              } else {
                _this.retryCounter++;
                if (_this.retryCounter >= _this.maxRetriesForPolling) {
                  console.error('[HTTPEvent] Giving up on polling due to network issues');
                  _this.errorHandler(_context.t0);
                }
              }
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 18]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "catchUp", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(eventId, accountId, componentEventHost) {
        var _this$eventList;
        var previewToken,
          status,
          offset,
          newEvents,
          retry,
          type,
          playback,
          producerEvents,
          viewerEvents,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              previewToken = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
              status = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
              offset = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : '00:00:00';
              if (_this.areValidParams(eventId, accountId, componentEventHost)) {
                _context2.next = 5;
                break;
              }
              throw new Error("\n        invalid:\n        eventId: ".concat(eventId, "\n        accountId: ").concat(accountId, "\n        componentEventHost: ").concat(componentEventHost, "\n      "));
            case 5:
              newEvents = [];
              retry = false;
              _context2.prev = 7;
              // if eventstatus = archived, then call a different endpoint for catch up events
              type = DestinationTypeEnum.VIEWER;
              if (!(0, _isNull["default"])(status) && (status === ARCHIVED || status === COMPLETED || status === STAGED)) {
                type = DestinationTypeEnum.ARCHIVED;
                if (status === ARCHIVED) {
                  playback = true;
                } else {
                  playback = false;
                }
              }
              if (!_this.config.isProducer) {
                _context2.next = 19;
                break;
              }
              _context2.next = 13;
              return _this.getComponentEvents(DestinationTypeEnum.PRODUCER, eventId, accountId, componentEventHost, null);
            case 13:
              producerEvents = _context2.sent;
              dmInstance.log("[HTTPEvent.catchUp] New component events received on catch up. length: ".concat(producerEvents.length));
              newEvents.push.apply(newEvents, _toConsumableArray(producerEvents));
              if (!(0, _isEmpty["default"])(producerEvents)) {
                retry = true;
              }
              _context2.next = 25;
              break;
            case 19:
              _context2.next = 21;
              return _this.getComponentEvents(type, eventId, accountId, componentEventHost, previewToken, playback, offset);
            case 21:
              viewerEvents = _context2.sent;
              newEvents.push.apply(newEvents, _toConsumableArray(viewerEvents));
              dmInstance.log("[HTTPEvent.catchUp] New component events received on catch up. length: ".concat(viewerEvents.length));
              if (!(0, _isEmpty["default"])(viewerEvents)) {
                if (!(0, _isNull["default"])(status) && (status === ARCHIVED || status === COMPLETED || status === STAGED)) {
                  retry = false; // for archived playback, all events prior to event start are returned. set retry=false here to prevent loop. 
                } else {
                  retry = true;
                }
              }
            case 25:
              _context2.next = 30;
              break;
            case 27:
              _context2.prev = 27;
              _context2.t0 = _context2["catch"](7);
              throw _context2.t0;
            case 30:
              (_this$eventList = _this.eventList).push.apply(_this$eventList, newEvents);
              if (!retry) {
                _context2.next = 33;
                break;
              }
              return _context2.abrupt("return", _this.catchUp(eventId, accountId, componentEventHost, previewToken, status));
            case 33:
              return _context2.abrupt("return", _toConsumableArray(_this.eventList));
            case 34:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[7, 27]]);
      }));
      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getComponentEvents", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(type) {
        var eventId,
          accountId,
          componentEventHost,
          previewToken,
          playback,
          offset,
          paramData,
          params,
          res,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              eventId = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : _this.eventId;
              accountId = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : _this.accountId;
              componentEventHost = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : _this.componentEventHost;
              previewToken = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
              playback = _args3.length > 5 ? _args3[5] : undefined;
              offset = _args3.length > 6 ? _args3[6] : undefined;
              if (_this.areValidParams(eventId, accountId, componentEventHost)) {
                _context3.next = 8;
                break;
              }
              throw new Error("\n        invalid:\n        eventId: ".concat(eventId, "\n        accountId: ").concat(accountId, "\n        componentEventHost: ").concat(componentEventHost, "\n      "));
            case 8:
              paramData = {}; // 'archived' type needs anyBand to equal false in order to avoid returning inBand events
              // 'producer' type endpoint actually ignores the anyBand parameter.
              // TODO should refactor to make cleaner paths for each 'type'
              if (type === DestinationTypeEnum.VIEWER) {
                paramData.anyBand = true;
              }
              !(0, _isNull["default"])(playback) ? paramData.playback = playback : null;
              if (!(0, _isNull["default"])(_this.nextIds[type])) {
                paramData.next = _this.nextIds[type];
              }
              if (previewToken) {
                paramData.token = previewToken;
              }
              paramData.startTimeOffset = offset;
              params = _qs["default"].stringify(paramData);
              _context3.prev = 15;
              _context3.next = 18;
              return HTTPEvent.localAxios.get("".concat(componentEventHost, "/account/").concat(accountId, "/event/").concat(eventId, "/componentEvent/").concat(type, "/key?").concat(params), {
                headers: {
                  'Content-Type': 'application/json'
                },
                withCredentials: true
              });
            case 18:
              res = _context3.sent;
              if (!((0, _isUndefined["default"])(res.data.pagination) || (0, _isUndefined["default"])(res.data.pagination.next))) {
                _context3.next = 21;
                break;
              }
              return _context3.abrupt("return", res.data.data);
            case 21:
              _this.nextIds[type] = res.data.pagination.next;
              return _context3.abrupt("return", res.data.data);
            case 25:
              _context3.prev = 25;
              _context3.t0 = _context3["catch"](15);
              throw _context3.t0;
            case 28:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[15, 25]]);
      }));
      return function (_x7) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "postEvent", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(metadata, data) {
        var componentEventHost,
          inBand,
          destinationType,
          accountId,
          eventId,
          res,
          postUrl,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              componentEventHost = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : _this.componentEventHost;
              inBand = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : false;
              destinationType = metadata.destinationType, accountId = metadata.accountId, eventId = metadata.eventId;
              if (_this.areValidParams(eventId, accountId, componentEventHost)) {
                _context4.next = 5;
                break;
              }
              throw new Error("\n        invalid:\n        eventId: ".concat(eventId, "\n        accountId: ").concat(accountId, "\n        componentEventHost: ").concat(componentEventHost, "\n      "));
            case 5:
              postUrl = "".concat(componentEventHost, "/account/").concat(accountId, "/event/").concat(eventId, "/componentEvent").concat(inBand ? '/inBand' : '');
              _context4.prev = 6;
              _context4.next = 9;
              return (0, _axios["default"])(postUrl, {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                withCredentials: true,
                params: {
                  destination: destinationType === 'audience' ? DestinationTypeEnum.VIEWER : destinationType
                },
                data: data
              });
            case 9:
              res = _context4.sent;
              _context4.next = 15;
              break;
            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](6);
              return _context4.abrupt("return", new Error(_context4.t0));
            case 15:
              return _context4.abrupt("return", res);
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[6, 12]]);
      }));
      return function (_x8, _x9) {
        return _ref4.apply(this, arguments);
      };
    }());
    this.dataHandler = dataHandler || this.missingHandler;
    this.errorHandler = errorHandler || this.missingHandler;

    // retry counter and max for determining when to give up on polling when there are network issues
    this.retryCounter = 0;
    this.maxRetriesForPolling = 5;
    this.pollIntervalReference = 0;
    this.accountId = null;
    this.eventId = null;
    this.componentEventHost = null;
    this.store = null;
    this.nextIds = {
      viewer: null,
      producer: null
    };
    this.eventList = [];
    this.config = _objectSpread({
      isProducer: true,
      pollingInterval: DEFAULT_POLLING_INTERVAL
    }, config);
  }
  return _createClass(HTTPEvent, [{
    key: "setStore",
    value: function setStore(store) {
      this.store = store;
    }
  }, {
    key: "missingHandler",
    value: function missingHandler() {
      throw new Error('Missing handler function!');
    }
  }, {
    key: "areValidParams",
    value: function areValidParams() {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }
      return !params.some(function (param) {
        return (0, _isNull["default"])(param) || (0, _isEmpty["default"])(param) || (0, _isUndefined["default"])(param);
      });
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(accountId, eventId, componentEventHost) {
        var previewToken,
          status,
          lastInBandEventId,
          type,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              previewToken = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : false;
              status = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : null;
              lastInBandEventId = _args5.length > 5 && _args5[5] !== undefined ? _args5[5] : null;
              // if a lastinbandeventId is given, use that as the 'next' parameter when beginning polling.
              // This is usually the case when beginning polling after a video stream interruption.
              if (lastInBandEventId) {
                type = this.config.isProducer ? DestinationTypeEnum.PRODUCER : DestinationTypeEnum.VIEWER;
                this.nextIds[type] = lastInBandEventId;
              }
              if (!this.pollIntervalReference) {
                _context5.next = 7;
                break;
              }
              console.warn('[HTTPEvent] Polling is already active, you must clear the previous poll to start HTTP polling.');
              return _context5.abrupt("return", false);
            case 7:
              if (this.areValidParams(eventId, accountId, componentEventHost)) {
                _context5.next = 9;
                break;
              }
              throw new Error("\n        invalid:\n        eventId: ".concat(eventId, "\n        accountId: ").concat(accountId, "\n        componentEventHost: ").concat(componentEventHost, "\n      "));
            case 9:
              this.accountId = accountId;
              this.eventId = eventId;
              this.componentEventHost = componentEventHost;

              //don't poll for COMPLETED, STAGED, or ARCHIVED
              if (!(!(0, _isNull["default"])(status) && !(status === ARCHIVED || status === COMPLETED || status === STAGED))) {
                _context5.next = 19;
                break;
              }
              console.log('[HTTPEvent] Setting up component event polling with pollingInterval: ' + this.config.pollingInterval);
              _context5.next = 16;
              return this.pollHandler(eventId, accountId, componentEventHost, previewToken);
            case 16:
              this.pollIntervalReference = setInterval(this.pollHandler.bind(this, eventId, accountId, componentEventHost, previewToken), this.config.pollingInterval);
              _context5.next = 20;
              break;
            case 19:
              console.log("[HTTPEvent] polling not used");
            case 20:
              return _context5.abrupt("return", true);
            case 21:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function open(_x10, _x11, _x12) {
        return _open.apply(this, arguments);
      }
      return open;
    }()
  }]);
}();
// local instance of axios created because we don't want to use the retry interceptor when polling
_defineProperty(HTTPEvent, "localAxios", _axios["default"].create({
  timeout: 10001,
  responseType: 'json'
}));